import React from 'react';
import { FormattedMessage } from 'react-intl';
import Proptypes from 'prop-types';
import BidBadge from '../../_shared/components/BidBadge';
import { CheckIcon, StyledTooltip } from './Styles';
import theme from '../../_shared/themes';

const propTypes = {
  testId: Proptypes.string,
  variant: Proptypes.string.isRequired,
  isFloorPriceMet: Proptypes.bool.isRequired,
  hasFloorPrice: Proptypes.bool.isRequired,
  isCloseToFloorPrice: Proptypes.bool.isRequired,
  tradeId: Proptypes.number
};

const defaultProps = {
  testId: null,
  tradeId: null
};

const FloorMeter = ({
  testId,
  variant,
  isFloorPriceMet,
  hasFloorPrice,
  isCloseToFloorPrice,
  tradeId
}) => {
  const testIdPrefix = testId ? `${testId}-` : '';
  const tradeIdTest = tradeId ? `-${tradeId}` : '';
  return (
    <>
      {isFloorPriceMet && (
        <>
          <BidBadge
            testId={`bid-floorMet-${variant}${tradeIdTest}`}
            variant="floorMet"
            dataTip
            dataFor={`${testIdPrefix}bid-isFloorPriceMet-${variant}`}
          >
            {/* Floor met */}
            <FormattedMessage id="vdp.floorMet" />{' '}
            <CheckIcon color={theme.COLORS.BASE} />
          </BidBadge>
          <StyledTooltip
            id={`${testIdPrefix}bid-isFloorPriceMet-${variant}`}
            arrowColor="transparent"
            effect="solid"
          >
            <FormattedMessage id="tooltips.isFloorPriceMet" />
          </StyledTooltip>
        </>
      )}
      <>
        {hasFloorPrice && !isFloorPriceMet && !isCloseToFloorPrice && (
          <>
            <BidBadge
              testId={`bid-hasFloorPrice-${variant}${tradeIdTest}`}
              variant="hasFloorPrice"
              dataTip
              dataFor={`${testIdPrefix}bid-hasFloorPrice-${variant}`}
            >
              {/* Floor not met */}
              <FormattedMessage id="vdp.hasFloorPrice" />
            </BidBadge>
            <StyledTooltip
              id={`${testIdPrefix}bid-hasFloorPrice-${variant}`}
              arrowColor="transparent"
              effect="solid"
            >
              <FormattedMessage id="tooltips.hasFloorPrice" />
            </StyledTooltip>
          </>
        )}
        {isCloseToFloorPrice && !isFloorPriceMet && (
          <>
            <BidBadge
              testId={`bid-closeToFloorPrice-${variant}${tradeIdTest}`}
              variant="closeToFloorPrice"
              dataTip
              dataFor={`${testIdPrefix}bid-closeToFloorPrice-${variant}`}
            >
              {/* Close to floor! */}
              <FormattedMessage id="vdp.closeToFloorPrice" />
            </BidBadge>
            <StyledTooltip
              id={`${testIdPrefix}bid-closeToFloorPrice-${variant}`}
              arrowColor="transparent"
              effect="solid"
            >
              <FormattedMessage id="tooltips.isCloseToFloorPrice" />
            </StyledTooltip>
          </>
        )}
      </>
    </>
  );
};

FloorMeter.propTypes = propTypes;
FloorMeter.defaultProps = defaultProps;

export default FloorMeter;
